<yc-modal *ngIf="loaded"
  [modalHeader]="isNomination ?
    ('MANAGE:hdrManageNominators' | ycI18n: 'Manage Nominators') :
    ('MANAGE:hdrManageApplicants' | ycI18n: 'Manage Applicants')"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="closeModal.emit()">
    <div class="row m-0">
      <div *ngIf="permissionsFormGroup" 
        class="col-md-5 add-applicant-panel">
        <h3 class="font-550 font-1-rem">
          <yc-i18n
            [key]="isNomination ?
              'APPLY:hdrAddNominator' :
              'APPLY:hdrAddApplicant'"
            [defaultValue]="isNomination ?
              'Add Nominator' :
              'Add Applicant'">
          </yc-i18n>
        </h3>
        <yc-i18n
          [key]="isNomination ?
            'APPLY:textAddNominatorDesc' :
            'APPLY:descriptionAddApplicant'"
          [defaultValue]="isNomination ?
            'Add additional nominators to this nomination and select what permissions they have.' :
            'Add additional applicants to this application and select what permissions they have.'">
        </yc-i18n>
        
        <ng-container *ngIf="!selectedApplicant">
          <gc-search-applicant-autocomplete
            [showEmailAddress]="false"
            [clearOnBlur]="false"
            [label]="isNomination ?
              ('APPLY:lblSearchForNominator' | ycI18n: 'Search for nominatior') :
              ('APPLY:lblSearchForApplicant' | ycI18n: 'Search for applicant')"
            [srOnlyLabel]="true"
            [placeholder]="isNomination ?
              ('GLOBAL:searchByNominatorEmail' | ycI18n: 'Search by nominator email') :
              ('common:textSearchByApplicantEmail' | ycI18n: 'Search by applicant email')"
            [showNoResults]="false"
            (onNoResults)="onNoResults($event)"
            (onTermChange)="onTermChange($event)"
            (onApplicantSelect)="selectApplicant($event)">
          </gc-search-applicant-autocomplete>

          <div *ngIf="showCreate && isValidEmail"
            [formGroup]="createApplicantFormGroup"
            class="row">
            <div class="col-md-12 mb-3 mt-3">
              <span>
                <yc-i18n 
                  [key]="isNomination ?
                    'APPLY:lblAddNominator' :
                    'APPLY:lblAddApplicant'" 
                  [defaultValue]="isNomination ?
                    'This nominator does not exist. Create a nominator below and assign permissions.' :
                    'This applicant does not exist. Create an applicant below and assign permissions.'">
                </yc-i18n>
              </span>
            </div>
            <div class="col-md-6">
              <yc-input
                [label]="'common:lblFirstName' | ycI18n:'First Name'"
                name="firstName">
              </yc-input>
            </div>
            <div class="col-md-6">
              <yc-input
                [label]="'common:lblLastName' | ycI18n:'Last Name'"
                name="lastName">
              </yc-input>
            </div>

            <div class="col-md-12">
              <yc-language-form-control
                [langKeys]="langKeys"
                name="languageCulture"
                [label]="'GLOBAL:lblLanguage' | ycI18n: 'Language'">
              </yc-language-form-control>
            </div>

            <div *ngIf="showEmployeeCheckbox"
              class="col-md-12 mt-3">
              <yc-checkbox
                name="isEmployeeOfClient"
                [optionLabel]="'common:textIsThisPersonAnEmployeeOfClientName' | ycI18n: 'Is this person an employee of __companyName__?': {
                  companyName: clientName
                }">
              </yc-checkbox>
            </div>
          </div>
          <div *ngIf="!isValidEmail && showCreate" class="mb-3">
            <small class="text-danger">
              <yc-i18n
                key="common:textPleaseEnterValidEmail" 
                defaultValue="Please enter a valid email">
              </yc-i18n>
            </small>
          </div>
        </ng-container>

        <gc-applicant-block
          *ngIf="selectedApplicant"
          [name]="selectedApplicant.firstName + ' ' + selectedApplicant.lastName"
          [email]="selectedApplicant.email"
          [phone]="selectedApplicant.phoneNumber"
          [initials]="selectedApplicant.firstName[0] +
            selectedApplicant.lastName[0]"
          [showClear]="true"
          (onClear)="selectedApplicant = null">
        </gc-applicant-block>
        
        <div *ngIf="selectedApplicant"
          [formGroup]="permissionsFormGroup"
          class="mt-3">
          <yc-checkbox-group
            [label]="'common:lblPermissions' | ycI18n: 'Permissions'"
            [options]="checkboxOptions"
            name="permissions">
          </yc-checkbox-group>
        </div>
        <div class="d-flex align-items-center mt-3 justify-content-end">
          <yc-button
            [link]="true"
            class="me-2"
            [langKey]="'common:linkClear'"
            [defaultText]="'Clear'"
            (onClick)="resetAddForm()">
          </yc-button>
          <yc-button *ngIf="showCreate"
            [primary]="true"
            class="me-2"
            [langKey]="'common:linkCreate'"
            [defaultText]="'Create'"
            [disabled]="!isValidEmail || createApplicantFormGroup.invalid"
            (onClick)="createApplicant()">
          </yc-button>
          <yc-button *ngIf="!showCreate"
            [primary]="true"
            [langKey]="'common:linkAdd'"
            [defaultText]="'Add'"
            [disabled]="!selectedApplicant"
            (onClick)="addApplicant()">
          </yc-button>
        </div>
      </div>

      <!-- Applicants -->
      <div [ngClass]="permissionsFormGroup ? 'col-md-7' : 'col-md-12'"
        class="d-none d-md-inline">
        <!-- Non Mobile -->
        <yc-table
          [simple]="true"
          [tableDescription]="'common:textManageCollaboratorPermissions' | ycI18n: 'Manage collaborator permissions'"
          [rows]="applicants">
          <ng-container *ycTableColumn="
            (isNomination ? 'common:textNominator' : 'common:lblApplicant'); 
            let row;
            prop: 'firstName',
            filterType: 'text'">
            <div>
              <strong>
                {{ row.firstName }}&nbsp;{{ row.lastName }}
              </strong>
            </div>
            <span>
              {{ row.email }}
            </span>
          </ng-container>
          
          <ng-container *ycTableColumn="'common:lblPermissions'; let row;">
            <ul>
              <li *ngIf="row.isApplicationOwner">
                <yc-i18n
                  [key]="isNomination ? 'APPLY:textOwnerOfNomination' : 'APPLY:textOwnerOfApplication'"
                  [defaultValue]="isNomination ?
                    'Owner of nomination' :
                    'Owner of application'">
                </yc-i18n>
              </li>
              <li *ngIf="row.canManageApplicants">
                <yc-i18n
                  [key]="isNomination ? 'APPLY:textCanAddEditDeleteNominators' : 'APPLY:textCanAddEditDeleteApplicants'"
                  [defaultValue]="isNomination ?
                    'Edit - Can add/edit and delete nominators' :
                    'Edit - Can add/edit and delete applicants'">
                </yc-i18n>
              </li>
              <li *ngIf="row.canReceiveEmails">
                <yc-i18n
                  [key]="isNomination ? 'APPLY:textReceivesNominationUpdateEmails' : 'APPLY:textReceivesApplicationUpdateEmails'"
                  [defaultValue]="isNomination ?
                    'Receives nomination update emails' :
                    'Receives application update emails'">
                </yc-i18n>
              </li>
            </ul>
          </ng-container>
          
          <ng-container *ycTableColumn="''; class: 'actions'; let row; let index = index">
            <div class="d-flex justify-content-end">

              <ng-template 
                *ngTemplateOutlet="deleteButton; context: { row: row }">
              </ng-template>
          
              <ng-template 
                *ngTemplateOutlet="changePermissionsButton; context: { row: row, index: index }">
              </ng-template>
            </div>
          </ng-container>
        </yc-table>
      </div>
      
      <!-- Mobile -->
      <div [ngClass]="permissionsFormGroup ? 'col-md-7' : 'col-md-12'"
        class="d-md-none p-0 mobile-wrapper">
        <div class="mobile-applicant-header">
          <yc-i18n
            key="common:lblApplicants"
            defaultValue="Applicants">
          </yc-i18n>
        </div>
        
        <div *ngFor="let row of applicants"
          class="mobile-applicant-block">
          <div class="d-flex justify-content-between">
            <!-- Applicant -->
            <div>
              <div>
                <strong>
                  {{ row.firstName }}&nbsp;{{ row.lastName }}
                </strong>
              </div>
              <span>
                {{ row.email }}
              </span>
            </div>
            <!-- Actions -->
            <div>
              <ng-template 
                *ngTemplateOutlet="deleteButton; context: { row: row }">
              </ng-template>

              <ng-template 
                *ngTemplateOutlet="changePermissionsButton; context: { row: row }">
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </yc-modal>

  <!-- Start Templates -->

<!-- Confirm Delete Template -->
<ng-template
  #confirmDeletePopoverTemplate 
  let-row="row"
  let-index="index">
  <div ycTrapFocus
    [returnFocusId]="'deletePermissionBtn' + index"
    role="dialog">
    <strong class="mb-3 d-block">
      <yc-i18n
        [key]="isNomination ?
        'APPLY:hdrRemoveNominator' :
        'APPLY:hdrRemoveApplicant'"
        [defaultValue]="isNomination ?
        'Remove Nominator' :
        'Remove Applicant'">
        </yc-i18n>
    </strong>
    <span>
      <yc-i18n
        [key]="isNomination ?
        'APPLY:textRemoveApplicantInfoDynamic' :
        'APPLY:textRemoveApplicantInfoDynamicApp'"
        [context]="{
        name: row.firstName + ' ' + row.lastName
        }"
        [defaultValue]="isNomination ?
        '__name__ will no longer have access to this nomination' :
        '__name__ will no longer have access to this application'">
        </yc-i18n>
    </span>
    <div class="d-flex align-items-center justify-content-end mb-2 mt-2">
      <yc-button
        [link]="true"
        [langKey]="'common:btnCancel'"
        class="me-4"
        [defaultText]="'Cancel'"
        (onClick)="row.deletePopover.hide()">
      </yc-button>
      <yc-button
        [primary]="true"
        [langKey]="'common:textRemove'"
        [defaultText]="'Remove'"
        (onClick)="removeCollaborator(row.id); row.deletePopover.hide();">
      </yc-button>
    </div>
  </div>
</ng-template>

<!-- Delete Button Template -->
<ng-template #deleteButton
  let-row="row"
  let-index="index">
  <yc-button *ngIf="canManage && !row.isApplicationOwner"
    [buttonElementId]="'deletePermissionBtn' + index"
    [icon]="true"
    [fontAwesomeIcon]="'times'"
    [textDanger]="true"
    [tooltipText]="'common:btnDelete' | ycI18n: 'Delete'"
    [popoverTemplate]="confirmDeletePopoverTemplate"
    [placement]="'left'"
    [popoverOutsideClickToClose]="false"
    [popoverContext]="{
      row: row
    }"
    (onPopoverReady)="onPopoverReady(row, $event, false)"
    (onPopoverClick)="setCurrentPopover(row, false)">
  </yc-button>
</ng-template>

<!-- Change Permissions Template -->
<ng-template
  #changePermissionsPopoverTemplate
  let-row="row"
  let-index="index">
  <div ycTrapFocus 
    [returnFocusId]="'changePermissionBtn' + index" 
    (onEscape)="resetFormGroup(row); row.permissionsPopover.hide()"
    role="dialog">
  <div [formGroup]="getFormGroup(row)">
    <yc-checkbox-group
      name="permissions"
      [label]="'common:lblPermissionsForUser' | ycI18n: 'Permissions for __name__': {
        name: row.firstName + ' ' + row.lastName
      }"
      [labelPrefix]="'edit' + index"
      [options]="editCheckboxOptions">
    </yc-checkbox-group>
  </div>

    <div class="d-flex align-items-center justify-content-end mb-2">
      <yc-button
        [link]="true"
        [langKey]="'common:btnCancel'"
        [borderOnHover]="true"
        class="me-4"
        [defaultText]="'Cancel'"
        (onClick)="resetFormGroup(row); row.permissionsPopover.hide()">
      </yc-button>
      <yc-button
        [primary]="true"
        [langKey]="'common:btnSave'"
        [defaultText]="'Save'"
        (onClick)="updateCollaboratorPermissions(row); row.permissionsPopover.hide();">
      </yc-button>
    </div>
  </div>
</ng-template>

<!-- Change Permissions Button Template -->
<ng-template #changePermissionsButton
  let-row="row"
  let-index="index">
  <yc-button *ngIf="canManage"
    [buttonElementId]="'changePermissionBtn' + index"
    [icon]="true"
    [fontAwesomeIcon]="'pencil'"
    [tooltipText]="'common:textChangePermissions' | ycI18n: 'Change permissions'"
    [popoverTemplate]="changePermissionsPopoverTemplate"
    [placement]="'left'"
    [popoverOutsideClickToClose]="false"
    [popoverContext]="{
      index: index,
      row: row
    }"
    (onPopoverReady)="onPopoverReady(row, $event, true)"
    (onPopoverClick)="setCurrentPopover(row, true)">
  </yc-button>
</ng-template>

<!-- End Templates -->
